import { NgIf, NgFor, NgClass } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { Router, RouterLink } from '@angular/router';
import { SummaryCardAction, SummaryCardComponent } from '@next/core-lib/components';
import { LocaleService, TranslatePipe } from '@next/core-lib/i18n';

import { Cycle } from '../../models/cycle.model';

@Component({
  selector: 'app-cycle-overview-panel',
  templateUrl: './cycle-overview-panel.component.html',
  styleUrls: ['./cycle-overview-panel.component.scss'],
  imports: [
    SummaryCardComponent,
    NgIf,
    NgFor,
    NgClass,
    MatButton,
    RouterLink,
    MatIcon,
    TranslatePipe,
  ],
})
export class CycleOverviewPanelComponent {
  @Input() selectedCycle: Cycle;
  @Input() totals?: Array<{ title: string; value: number | string; col_width: number }>;
  @Input() hasItems?: boolean;
  @Input() panelSubject: string;
  @Input() isMobile: boolean;
  @Input() showAddButton: boolean;

  constructor(
    private readonly locale: LocaleService,
    private readonly router: Router,
  ) {}

  getActions(): SummaryCardAction[] {
    const actionItems: SummaryCardAction[] = [];

    switch (this.panelSubject) {
      case 'day-old-chick':
      case 'departure':
      case 'balance':
        actionItems.push({
          id: this.panelSubject + '-overview-button',
          label: this.isMobile
            ? undefined
            : this.locale.translate(`cycle-overview.panel.${this.panelSubject}-overview`),
          icon: 'arrow_forward',

          callback: () => {
            this.router.navigate(['/cycle', this.selectedCycle.id, this.panelSubject]);
          },
        });
        break;
    }

    return actionItems;
  }
}
